import React from "react";
import { motion } from "framer-motion";
import { FaWhatsapp, FaFacebookF, FaXTwitter, FaLinkedinIn, FaPinterestP } from "react-icons/fa6";
import "./AlumniHeroSection.css";
// Local file import
import alumni2 from "../../assets/NIECCE Alumni.avif";

// Remote URLs – just assign to variables
const alumni1 = "https://static.wixstatic.com/media/6870b3_45ba7214e84e47b797885aa4b09c6966~mv2.jpg/v1/crop/x_77,y_303,w_1116,h_612/fill/w_864,h_474,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/NTT%20Teachers%20indiranagar.jpg";
const alumni3 = "https://static.wixstatic.com/media/6870b3_063f0b52aa2d4faba21e26a0d1e20ff0~mv2.jpg/v1/fill/w_996,h_666,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/6870b3_063f0b52aa2d4faba21e26a0d1e20ff0~mv2.jpg";
const alumni4 = "https://static.wixstatic.com/media/6870b3_5b730753cb774f11b1ba8c3494c6247b~mv2.jpg/v1/fill/w_436,h_328,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/grp%20pic.jpg";
const alumni5 = "https://static.wixstatic.com/media/6870b3_6e8b9225dc2d4a1f80d7a8a258660e9c~mv2.jpeg/v1/fill/w_888,h_666,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/6870b3_6e8b9225dc2d4a1f80d7a8a258660e9c~mv2.jpeg";


const AlumniHeroSection = () => {
  return (
    <section className="alumni-section">
      <div className="alumni-container">
        {/* --- Left Text Section --- */}
        <motion.div
          className="alumni-text"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2>
            <span className="blue-text">Celebrating Excellence:</span>{" "}
            <span className="red-text">NIECCE Alumni Network</span>
          </h2>

          <p className="description">
            Welcome to the NIECCE Alumni Network, where we honor the achievements and contributions of our esteemed graduates. 
            As pioneers in early childhood education, our alumni have made significant strides in shaping the future of education. 
            With over 20 years of expertise and a strong network of professionals, NIECCE continues to empower educators and 
            foster lifelong connections. Join us in celebrating success stories, sharing experiences, and building a brighter future together.
          </p>

          <h2 className="upcoming">
            Upcoming...
            <br />
            <span className="highlight">Alumni Excellence Awards Event!</span>
          </h2>

          <p className="subtext">
            Here's your opportunity to nominate yourself for NIECCE's Alumni Excellence Awards! Share your achievements with us 
            and inspire future generations of teachers who look up to you as role models.
          </p>

          <motion.a
            href="https://docs.google.com/forms/d/e/1FAIpQLSeHitjNyGmQFtSSDTBUjWiCZAJk9ukeo3pHQHoDTF7PSHtoqg/viewform?usp=sf_link"
            target="_blank"
            rel="noreferrer"
            className="nominate-btn"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Nominate Now →
          </motion.a>

          <p className="share-invite">
            <strong>Share this page</strong> with your batchmates to encourage them to nominate themselves.
          </p>

          {/* --- Share Buttons --- */}
          <div className="share-buttons">
            <a href="https://api.whatsapp.com/send/?text=https://www.niecce.com/alumni" target="_blank" rel="noreferrer">
              <FaWhatsapp className="whatsapp" />
            </a>
            <a href="https://facebook.com/sharer/sharer.php?u=https://www.niecce.com/alumni" target="_blank" rel="noreferrer">
              <FaFacebookF className="facebook" />
            </a>
            <a href="https://twitter.com/intent/tweet?url=https://www.niecce.com/alumni" target="_blank" rel="noreferrer">
              <FaXTwitter className="twitter" />
            </a>
            <a href="https://www.linkedin.com/shareArticle?mini=true&url=https://www.niecce.com/alumni" target="_blank" rel="noreferrer">
              <FaLinkedinIn className="linkedin" />
            </a>
            <a href="https://pinterest.com/pin/create/button/?url=https://www.niecce.com/alumni" target="_blank" rel="noreferrer">
              <FaPinterestP className="pinterest" />
            </a>
          </div>
        </motion.div>

{/* --- Right Image Section --- */}
<motion.div
  className="alumni-images"
  initial={{ opacity: 0, x: 50 }}
  whileInView={{ opacity: 1, x: 0 }}
  transition={{ duration: 0.8 }}
>
  <div className="image-wrapper main">
    <img src={alumni1} alt="NIECCE teacher training alumni" title="NIECCE teacher training alumni" />
  </div>
  <div className="image-wrapper sub1">
    <img src={alumni2} alt="NIECCE alumni event" title="NIECCE alumni event" />
  </div>
  <div className="image-wrapper sub2">
    <img src={alumni3} alt="NIECCE teacher training alumni gathering" title="NIECCE teacher training alumni gathering" />
  </div>
  <div className="image-wrapper sub3">
    <img src={alumni4} alt="NIECCE alumni achievement event" title="NIECCE alumni achievement event" />
  </div>
  <div className="image-wrapper sub4">
    <img src={alumni5} alt="NIECCE nursery teacher training alumni" title="NIECCE nursery teacher training alumni" />
  </div>
</motion.div>

      </div>
    </section>
  );
};

export default AlumniHeroSection;
